import * as React from 'react';

import { MantineAccordion } from 'components/bootstrap';
import { MarkdownPreview } from 'components/common/MarkdownEditor';
import { Row } from 'common/components/layout-styles';
import StepActionsButton from 'security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

type LabelProps = {
  step: EventProcedureStepAPIType;
  order: number;
  eventId?: string;
};

function StepLabel({ step, order, eventId = undefined }: LabelProps) {
  return (
    <Row $align="center" $justify="space-between" style={{ paddingRight: '0.5rem' }}>
      <Row $align="center" $gap="sm" $width="auto">
        <span>{order}.</span>
        <span>{step.title || `Step ${order}`}</span>
      </Row>
      <Row $align="center" $gap="sm" $width="auto">
        <StepActionsButton step={step} eventId={eventId} />
      </Row>
    </Row>
  );
}

type Props = {
  steps: Array<EventProcedureStepAPIType>;
  eventId?: string;
};

function StepListView({ steps, eventId = undefined }: Props) {
  const items: Array<any> = React.useMemo(
    () =>
      steps.map((step: EventProcedureStepAPIType, index: number) => ({
        value: step.id,
        label: <StepLabel step={step} order={index + 1} eventId={eventId} />,
        content: step.description ? (
          <MarkdownPreview value={step.description} maxHeight={300} noBackground noBorder noPadding show />
        ) : (
          <i>No description set for this step</i>
        ),
      })),
    [eventId, steps],
  );

  return <MantineAccordion variant="separated" chevronPosition="right" accordionItems={items} defaultValue={null} />;
}

export default StepListView;
